import { setDay } from 'date-fns';
import { useMemo } from 'react';
import { useIntl } from '../../../../../theme/i18n';
export var useWeekDays = () => {
  var {
    locale
  } = useIntl();

  var getWeekDay = (_, i) => {
    // eslint-disable-next-line no-restricted-syntax
    var weekDay = new Intl.DateTimeFormat(locale, {
      weekday: 'short'
    }).format(setDay(new Date(), i)); // eslint-disable-next-line no-restricted-syntax

    var weekDayLong = new Intl.DateTimeFormat(locale, {
      weekday: 'long'
    }).format(setDay(new Date(), i)); // XXX display two letters day name for english

    return {
      label: locale.startsWith('en') ? weekDay.substring(0, 2) : weekDay,
      fullLabel: weekDayLong
    };
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  return useMemo(() => Array.from({
    length: 7
  }).map(getWeekDay), []);
};
//# sourceMappingURL=useWeekDays.js.map